<span mat-sort-header="latestSignatureRequestStatus">
  <mat-icon svgIcon="yousign" matTooltip="Statut de la demande de signature Yousign"></mat-icon>
</span>

<span mat-sort-header="latestSignatureRequestCreatedAt">
  <svg matTooltip="Demande créée le" lucideRocket></svg>
</span>
<span mat-sort-header="latestSignatureRequestExpiresAt">
  <svg matTooltip="Date d'expiration" lucideCalendarX></svg>
</span>
<span mat-sort-header="latestSignatureRequestSignedAt">
  <svg matTooltip="Date de signature" lucideSignature></svg>
</span>
